import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EnvironmentToken } from '../../../app.config';
import {
  OpeningHour,
  StoreOpeningHourPayload,
  UpdateOpeningHourPayload,
} from '../../models/catalog/opening-hour.model';

/**
 * Mutation-only — list of OpeningHours comes embedded in the parent
 * OpeningHourType view. Reload the parent after each mutation to refresh
 * the rows.
 */
@Injectable({ providedIn: 'root' })
export class OpeningHourService {
  #http = inject(HttpClient);
  #apiUrl = inject(EnvironmentToken).apiUrl;

  createForType(
    typeId: number,
    payload: StoreOpeningHourPayload,
  ): Observable<{ data: OpeningHour }> {
    return this.#http.post<{ data: OpeningHour }>(
      `${this.#apiUrl}/api/admin/catalog/opening-hour-types/${typeId}/hours`,
      payload,
    );
  }

  update(
    id: number,
    payload: UpdateOpeningHourPayload,
  ): Observable<{ data: OpeningHour }> {
    return this.#http.patch<{ data: OpeningHour }>(
      `${this.#apiUrl}/api/admin/catalog/opening-hours/${id}`,
      payload,
    );
  }

  delete(id: number): Observable<unknown> {
    return this.#http.delete(
      `${this.#apiUrl}/api/admin/catalog/opening-hours/${id}`,
    );
  }
}
